import React from 'react';
import { useHistory } from 'react-router-dom';

import {
	FaRegMap,
	FaGlobeAmericas,
	FaRegFileAlt,
	// FaInfoCircle
	// FaDownload,
} from 'react-icons/fa';

import { VscLibrary } from 'react-icons/vsc';
import { FiHelpCircle } from 'react-icons/fi';

import { RiRoadMapLine } from 'react-icons/ri';
import Card from '~/Components/Card';
import { Container, MiniCards, CardsTitle, Content } from './styles';
import { COLORS } from '~/styles/colors';

const NewsCards = () => {
	const history = useHistory();

	return (
		<Container>
			<CardsTitle>ACESSE</CardsTitle>
			<Content>
				<MiniCards>
					<Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						text="DIVIGEO"
						onClick={() => history.push('article/divigeo')}
						icon={
							<FaGlobeAmericas
								size={48}
								color={COLORS.fgPrimary}
							/>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						onClick={() => history.push('/map')}
						icon={<FaRegMap size={48} color={COLORS.fgPrimary} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>MAPA</span>
								<span>INTERATIVO</span>
							</span>
						}
					/>
					 <Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						text="METADADOS"
						onClick={() => history.push('/media/metadados')}
						icon={
							<RiRoadMapLine size={48} color={COLORS.fgPrimary} />
						}
					/> 
					<Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						onClick={() => history.push('/media/mapoteca-digital')}
						icon={<VscLibrary size={48} color={COLORS.fgPrimary} />}
						text={['MAPOTECA DIGITAL']}
					/>
					{/* <Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						onClick={() => history.push('/media/info-basica-zoneamento')}
						icon={<FaInfoCircle size={48} color={COLORS.fgPrimary} />}
						text={['INFORMAÇÃO BÁSICA POR ZONEAMENTO']}
					/> */}
					<Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						onClick={() => history.push('/services')}
						icon={
							<FaRegFileAlt size={48} color={COLORS.fgPrimary} />
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>EMISSÃO DE</span>
								<span>DOCUMENTOS</span>
							</span>
						}
					/> 
					{/* <Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						text={['TRANSFERÊNCIA DE DADOS']}
						onClick={() =>
							history.push('/media/transferencia-de-dados')
						}
						icon={<FaDownload size={48} color={COLORS.fgPrimary} />}
					/> */}
					<Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						text={['TUTORIAIS']}
						onClick={() => history.push('/media/tutoriais')}
						icon={
							<FiHelpCircle size={48} color={COLORS.fgPrimary} />
						}
					/>
					{/* <NewsCard
						color="#278AAE"
						text={['PRÉ-CONSULTA PARA FINS DE CONSTRUÇÃO']}
						onClick={() => {
							dispatch(
								setState({
									presselected: 'consulta-construcao',
								})
							);
							history.push('/services');
						}}
					/> */}
					{/* <NewsCard
						color="#278AAE"
						text={['CONSULTA AMBIENTAL']}
						onClick={() => {
							dispatch(
								setState({ presselected: 'consulta-ambiental' })
							);
							history.push('/services');
						}}
					/> */}
				</MiniCards>
			</Content>
		</Container>
	);
};

export default NewsCards;
